import { trackLink } from './utils.js';

onDomReady(function() {
   $$('.js-carousel-link').each(function(el) {
      trackLink(el, el.get('data-ga-category'), 'click', el.get('data-ga-label'));
   });
});
